import React, { useEffect, useRef, useState } from 'react';
import { Box, Button } from '@mui/material';
import './see-more-less.css'

const AppSeeMoreLess = ({ children, clampLines = 2 }) => {
    const contentRef = useRef(null);
    const [isClamped, setIsClamped] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);


    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        const checkOverflow = () => {
            setIsOverflowing(el.scrollHeight > el.clientHeight);
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, []);

    const toggleClamp = () => {
        setIsClamped(!isClamped);
    };

    return (
        <Box>
            <Box
                ref={contentRef}
                className={'text-truncate-line-2'}
                sx={{
                    lineClamp: isClamped ? 'none' : clampLines,
                    WebkitLineClamp: isClamped ? 'none' : clampLines
                }}
            >
                {children}
            </Box>
            {isOverflowing && (
                <Button
                    variant='text'
                    color="inherit"
                    size="small"
                    onClick={(e) => {
                        e.preventDefault();
                        toggleClamp();
                    }}
                    sx={{
                        p: 0,
                        minWidth: 'inherit',
                        textDecoration: 'underline',
                    }}
                >
                    See {isClamped ? 'less' : 'more'}
                </Button>
            )}
        </Box>
    );
};

export default AppSeeMoreLess;
